// extracted by mini-css-extract-plugin
module.exports = {"container":"RatingType_container__1S1MS","rating_stars_container":"RatingType_rating_stars_container__20KKM"};